import React from "react";

import { Col, Row } from "react-bootstrap";


export const DepartmentHeader = ({ deptName, listName, provName, deptLogo }) => {

    return (
        <Row>
          <Col lg={3} md={12} sm={12} className="d-flex justify-content-center">
            <img alt="dept-logo" src={deptLogo} style={{ display: "inline", width: "100px", borderRadius: "5px"}} />
          </Col>
          <Col lg={9} md={12} sm={12} >
            <h3 className="pt-5"> {deptName} </h3> 
            <h4 className="text-muted"> {provName} </h4>
            <h4> {listName} </h4>
          </Col>
        </Row>
    );
};